import { getHttpService } from './HttpService';
import { error } from '@/utils/error';
import { CLIENT_CONTROLLER } from '@/constants';
import type { Insured, ProductChoice } from '@/types/entities';

interface Args {
    collectivityNumber?: string;
    insuredPerson: Insured;
    productChoice: ProductChoice;
    paymentTerm: number;
    proposition: string;
    email: string;
    backToFunnelLink: string;
}

interface GetQuoteResponse {
    data: GetQuote;
}

interface GetQuote {
    isSucces: boolean;
    isVerzonden: boolean;
    errorCode?: null;
    statusCode: number;
    loginAlsKlantSessieNotActive: boolean;
    content?: null;
}

const HttpService = getHttpService();

const getQuote = async ({
    collectivityNumber,
    insuredPerson,
    productChoice,
    paymentTerm,
    proposition,
    email,
    backToFunnelLink
}: Args): Promise<GetQuote> => {
    const path = '/clientcontroller/salesfunnelclient/aanvragenofferte';

    const payload = {
        Collectiviteitnummer: collectivityNumber,
        Verzekerden: insuredPerson,
        Pakketkeuzes: productChoice,
        Betaaltermijn: paymentTerm,
        Propositie: proposition,
        Email: email,
        TerugNaarSalesfunnelLink: backToFunnelLink
    };

    const { data } = (await HttpService.post(path, payload)) as GetQuoteResponse;

    if (data.isSucces === false) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, {
            path,
            payload: JSON.stringify(payload)
        });
    }

    return data;
};

export default {
    getQuote
};
